import { FormHelperText } from "@mui/material";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { useTranslation } from "react-i18next";

const PhoneNumberInput = ({
  field,
  label,
  error,
  required,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* <Stack direction="row" alignItems="center" spacing={0.5} mb={1.2}>
        <Typography
          variant="body2"
          sx={{
            fontFamily: FONT_FAMILY,
            color: "neutral.main",
            whiteSpace: "pre-wrap",
            fontSize: "1rem",
            fontWeight: 600,
            marginTop: "20px",
            marginBottom: "16px",
            "@media(max-width: 500px)": { fontSize: "0.8rem" },
          }}
        >
          {label}
        </Typography>
        {required && (
          <Typography component="span" color="error">
            *
          </Typography>
        )}
      </Stack> */}
      <PhoneInput
        defaultCountry={"SA"}
        international
        disabled={disabled}
        numberInputProps={{
          type: "text",
          inputMode: "tel",
          autoComplete: "tel",
          maxLength: 16,
          style: {
            width: "100%",
            height: "56px",
            backgroundColor: "transparent",
            fontSize: "1rem",
            borderRadius: "8px",
            borderWidth: "0px",
          },
        }}
        style={{
          border: "1px solid #ced4da",
          borderRadius: "8px",
          paddingLeft: "12px",
          paddingRight: "12px",
          // borderColor: errorMessage ? "#d32f2f" : "#ced4da",
        }}
        // limitMaxLength={true}
        // numberInputProps={{ maxLength: 16 }}
        value={field.value}
        onChange={(value) => onChange(value || "")}
        placeholder="+966XXXXXXX"
      />

      <FormHelperText color="error" sx={{ color: "error.main" }}>
        {field.value === "" || error !== undefined
          ? error // Show this message when value is empty or undefined
          : isValidPhoneNumber(field.value)
            ? undefined // If value is valid, no error
            : t("auth.common.phone_number_invalid")}{" "}
      </FormHelperText>
    </>
  );
};

export default PhoneNumberInput;
